import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useXMLViewerContext } from '../../context/xml-viewer-context';
export function CDataTag(props) {
    const { indentation, children, isInline } = props;
    const { theme } = useXMLViewerContext();
    return (_jsxs("div", { style: { color: theme.cdataColor }, children: [_jsx("span", { children: `${indentation}<![CDATA[` }), children, _jsx("span", { children: `${isInline ? '' : indentation}]]>` })] }));
}
//# sourceMappingURL=index.js.map